import { render } from "./AmplifyTopicSelector.vue?vue&type=template&id=7361aec7&scoped=true"
import script from "./AmplifyTopicSelector.vue?vue&type=script&lang=js"
export * from "./AmplifyTopicSelector.vue?vue&type=script&lang=js"

import "./AmplifyTopicSelector.vue?vue&type=style&index=0&id=7361aec7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7361aec7"]])

export default __exports__